import { Component, OnInit } from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {AccountService} from '../../../services/account.service';
import {ApplicationService} from '../../../services/application.service';

interface IValidation {
  id: number;
  name: string;
}
@Component({
  selector: 'app-add-broker',
  templateUrl: './add-broker.component.html',
  styleUrls: ['./add-broker.component.scss']
})

export class AddBrokerComponent extends CommonComponent implements OnInit {
  validation: IValidation | any; // Interface with the values
  display = false;
  brokerCode: string | null = null;
  constructor(
    private applicationService: ApplicationService,
    private accountService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
  }
  verifyBrokerCode() {
    this.loadingModalOn();
    this.applicationService.getCodeValidation(this.brokerCode).subscribe(
      response => {
        this.validation = response;
        this.display = true;
        this.loadingModalOff();
      },
      error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  confirmBroker(){
    this.loadingModalOn();
    if (this.validation !== null){
      this.accountService.postReferredBroker(this.validation.id).subscribe(
        () => {
          this.msgSuccess($localize`:@@brokerConfirmation:Haz sido asociado correctamente.`);
          this.display = false;
          this.loadingModalOff();
          this.router.navigate(['/account/balance']);
        }, error => {
          this.msgError(error);
          this.display = false;
          this.loadingModalOff();
        }
      );
    }
  }
}
